module.exports = {
  '0'  : '0-Doubtful',
  '1'  : '1-Possible ADR',
  '2'  : '2-Possible ADR',
  '3'  : '3-Possible ADR',
  '4'  : '4-Possible ADR',
  '5'  : '5-Probable ADR',
  '6'  : '6-Probable ADR',
  '7'  : '7-Probable ADR',
  '8'  : '8-Probable ADR',
  '9'  : '9-Definite ADR',
  '10' : '10-Definite ADR'
};
